import { formatPhone, formatSSN } from '@lili/lili-frontend-common';
import { MAIN_INCOME_SOURCE } from '@Store/index.ts';

export function getEnumValueOrDefault<T extends object>(
  enumObj: T,
  value: T | undefined | T[keyof T],
  defaultValue: T[keyof T]
): T[keyof T] {
  const enumValues = Object.values(enumObj) as unknown as string[];
  const enumKeys = Object.keys(enumObj) as unknown as (keyof T)[];

  if (value !== undefined && enumValues.includes(value as unknown as string)) {
    const key = enumKeys.find((k) => enumObj[k] === value);
    if (key !== undefined) {
      return enumObj[key];
    }
  }

  return defaultValue;
}

export const formatPhoneForView = (phoneNumber: string) => formatPhone(phoneNumber);

export const formatPhoneForMaskedDefaultValue = (phoneNumber: string) => {
  /** Currently support US number as hardcoded +1 */
  return phoneNumber?.replace(/(\+1)(\d{3})(\d{3})(\d{4})/, '$1 ($2) $3-$4');
};

export const formatPhoneNumberForStore = (phoneNumber: string) => {
  /** Keep prefix country Ex: +1 and remove all the spaces and "(" ")" */
  return phoneNumber.replace(/[^\d+]/g, '');
};

export const formatSsnForView = (ssn: string) => formatSSN(ssn);

export const getIncomeSourceTitle = (incomeSource: MAIN_INCOME_SOURCE | undefined) => {
  switch (incomeSource) {
    case MAIN_INCOME_SOURCE.S_CORP:
      return 'Corporation (S-Corp)';
    case MAIN_INCOME_SOURCE.C_CORP:
      return 'Corporation (C-Corp)';
    case MAIN_INCOME_SOURCE.GENERAL_PARTNERSHIP:
      return 'General Partnership';
    case MAIN_INCOME_SOURCE.LIMITED_LIABILITY_PARTNERSHIP:
      return 'Limited Liability Partnership';
    case MAIN_INCOME_SOURCE.MULTI_MEMBER_LLC:
      return 'Multi-Member LLC';
    case MAIN_INCOME_SOURCE.SINGLE_MEMBER_LLC:
      return 'Single-Member LLC';
    case MAIN_INCOME_SOURCE.SOLE_PROP_DBA:
      return 'Sole proprietor with DBA';
    case MAIN_INCOME_SOURCE.SOLE_PROP_NO_DBA:
      return 'Sole proprietor';
    default:
      return '';
  }
};
